import { useCallback, useEffect, useMemo } from "react";
import { Datagrid, useListContext } from "react-admin";
import { useNavigate } from "react-router";
import { queryToNoHashLink } from "shared/src/utils/decodeQuery";

export const DatagridWithHistory = ({ listItems, setListItems, rowClick, ...props }) => {
    const navigate = useNavigate();
    const { resource, data } = useListContext();

    const redirectWithHistory = useCallback(
        (id) => {
            const searchParams = queryToNoHashLink();
            navigate({
                pathname: `/${resource}/${id}/show`,
                search: searchParams ? `?from=${searchParams}` : "",
            });
        },
        [navigate, resource]
    );

    const memoizedRowClick = useMemo(
        () => rowClick ?? redirectWithHistory,
        [rowClick, redirectWithHistory]
    );

    const datagridProps = useMemo(
        () => ({
            ...props,
            rowClick: memoizedRowClick,
        }),
        [props, memoizedRowClick]
    );

    useEffect(() => {
        if (listItems && data && listItems !== data && setListItems) {
            requestAnimationFrame(() => {
                setListItems(data);
            });
        }
    }, [data, listItems, setListItems]);

    return <Datagrid {...datagridProps} />;
};
